export default __webpack_public_path__ + "static/media/04.666a7a05.png";